<template>
  <v-dialog close v-model="dialog" max-width="500">
    <v-card>
      <v-card-title class="headline-2 pl-4 mb-5 primary white--text">
        Filter Saldo Cuti<v-spacer></v-spacer>
        <v-btn id="generateCuti" icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn></v-card-title
      >
      <v-card-text>
        <v-form @submit.prevent data-vv-scope="form" lazy-validation>
          <v-row wrap>
            <v-col cols="12" sm="12" md="12" lg="12" class="pa-1">
              <v-select
                id="kategori"
                dense
                single-line
                outlined
                editable="false"
                :items="kategories"
                name="Kategori"
                label="Kategori Ketidakhadiran"
                placeholder="Kategori Ketidakhadiran"
                v-model="kategori"
                hint="Pilih Kategori"
                data-vv-name="kategori"
                data-vv-as="Kategori"
                v-validate="'required'"
                item-text="nama"
                item-value="id"
                :return-object="true"
                :error-messages="errors.collect('form.kategori')"
                no-data-text="Belum tersedia kategori ketidakhadiran yang dibuat"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="pr-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn name="simpan" depressed color="primary" @click="$emit('filter', kategori)">
          <v-icon>mdi-check</v-icon>Terapkan
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      kategori: null,
    }
  },
  computed: {
    kategories() {
      return this.$store.getters['kategori/getItemsKategori']
    }
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false
    }
  },
}
</script>
